export default __webpack_public_path__ + "static/media/Careerbuilder-logo.15b39f9e.svg";